import { useConfirm as useStockConfirm } from 'components/ImagePickerModal/Stock/useConfirm'
import { useConfirm as useAIGenerationConfirm } from 'components/ImagePickerModal/AIGeneration/useConfirm'
import { useConfirm as useLinkConfirm } from 'components/ImagePickerModal/Link/useConfirm'
import { useImagePickerContext } from 'components/ImagePickerModal/ImagePickerContext'

export const useConfirm = () => {
  const { provider, selectedImages } = useImagePickerContext()
  const stockConfirm = useStockConfirm()
  const aiGenerationConfirm = useAIGenerationConfirm()
  const linkConfirm = useLinkConfirm()

  // The selected image can be from unsplash without the provider being set to 'stock'
  if (!!selectedImages[0]?.unsplash) return stockConfirm

  switch (provider) {
    case 'stock':
      return stockConfirm
    case 'ai':
      return aiGenerationConfirm
    case 'link':
      return linkConfirm
    case 'uploads':
      return { confirm: async () => {}, isConfirming: false }
    default:
      throw new Error('provider not supported')
  }
}
